import { CommonModule } from '@angular/common';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormlyCustomSelectOptionsPipe } from '@shared/pipes/custom-select-options.pipe';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'agreement-facility-radio',
  template: `

    <div class="p-g" style="width:500px;margin-bottom:10px">

        <div *ngFor="let option of props.options | formlyCustomSelectOptions:field | async; let i = index;"
        style="margin-top: 20px;"    
        [ngClass]="{
            'p-g-12  form-check': props.formCheck.indexOf('custom') === -1,
            'p-g-12  form-check-inline': props.formCheck === 'inline',
            'p-g-12  custom-control custom-radio': props.formCheck.indexOf('custom') === 0,
            'p-g-12  custom-control-inline': props.formCheck === 'custom-inline'
            }"
        >       

            <input type="radio"
                [id]="elementId + '_' + i"
                [class.form-check-input]="props.formCheck.indexOf('custom') === -1"
                [class.custom-control-input]="props.formCheck.indexOf('custom') === 0"
                [name]="field.name || id"
                [class.is-invalid]="showError"
                [attr.disabled]="option.disabled ? true : null"
                [attr.value]="option.value"
                [value]="option.value"
                [formControl]="formControl"
                [formlyAttributes]="field"
            >
            <label
                [class.form-check-label]="props.formCheck.indexOf('custom') === -1"
                [class.custom-control-label]="props.formCheck.indexOf('custom') === 0"
                [for]="elementId + '_' + i"
            >
                <span>{{'AGREEMENT_CREDITS.Step_1.mainRadioLabel' | translate }}</span>
                {{ getOpaName(i) }}<span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>        
            </label>

            <div style="margin-left: 5rem;" *ngFor="let uniquefacility of getUniqueFacilities(i)">
              <span [class.is-invalid]="showError">
                {{ uniquefacility.accountName }} ({{'AGREEMENT_CREDITS.Step_1.facilityID' | translate }}: {{ uniquefacility.facilityId }})
              </span>  
            </div>

        </div>
    
    </div>
  `,
  imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule, FormlyCustomSelectOptionsPipe, RadioButtonModule]
})
export class AgreementFacilityRadioComponent extends FieldType implements OnInit {
  defaultOptions = {
    templateOptions: {
      options: [],
      formCheck: 'custom', // 'custom' | 'custom-inline' | 'stacked' | 'inline'
    },
  };

  rawOptions: any;

  ngOnInit() {
    
    this.rawOptions = this.props.options;
  }


  constructor(){
    super();
  }

  getOpaName(index) {
    return this.rawOptions[index].opa;
  }

  getUniqueFacilities(index){
    return this.rawOptions[index].uniqueFacilities;
  }

  isData(option) {
    return option.data;
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }
}
